module.exports = __webpack_public_path__ + "static/img/1074_small.0925e51.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1074_small.png
// module id = a87P
// module chunks = 1